import { render, staticRenderFns } from "./DraftArticlesContainer.vue?vue&type=template&id=332937f7&scoped=true&"
import script from "./DraftArticlesContainer.vue?vue&type=script&lang=js&"
export * from "./DraftArticlesContainer.vue?vue&type=script&lang=js&"
import style0 from "./DraftArticlesContainer.vue?vue&type=style&index=0&id=332937f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332937f7",
  null
  
)

export default component.exports